<div class="col full-height layout-column" *ngIf="mutableRoute">

  <!-- Top summary route panel list item (Table Counterpart) -->
  <div class="summary-container table-outer-wrapper" [ngClass]="'table-routes-' + panel?.id" #summaryContainer style="position: relative;">
    <div class="table-inner-wrapper">
      <div class="routes-table-list-container">
        <app-routes-table-list-row [route]="mutableRoute"
                                   [settings]="settings.routes"
                                   [isSelected]="false"
                                   [isVisible]="visibleKeys[mutableRoute.id]"
                                   [isResourceView]="false"
                                   [excludeMode]="false"
                                   [allPanelIds]="[]"
                                   [panelId]="panel.id"
                                   [isSummaryRow]="true"
                                   (onRowClick)="onSelect.emit()"
                                   (onToggleVisible)="onToggleVisible.emit({route: $event.route, isVisible: $event.isVisible})"
                                   (onToggleLocked)="onToggleLockedRoute($event)"
                                   (onSelectRouteResource)="onSelectRouteResource.emit({route: $event.route, event: $event.event})">
        </app-routes-table-list-row>
      </div>
    </div>
  </div>

  <div class="table-outer-wrapper margin-top-5" [ngClass]="'table-' + uniqueId">
    <!-- Header: Scrolls horizontally with body, but stays fixed vertically -->
    <div class="header-container" #headerContainer
         [tableColumnManager]="uniqueId"
         [defaultWidths]="defaultWidths"
         [columnGroups]="columnGroups"
         [settings]="settings?.route"
         (settingsChange)="onSettingsChange.emit($event)">
      <div class="table-inner-wrapper">
        <div class="routes-stops-table-list-container">
          <div class="tr sticky-header">

            <div *ngIf="settings?.route?.columns?.id" class="th col-id sticky-col layout-row layout-align-start-center gap-5">
              <span translate>ID</span>
              <app-table-column-insert-button></app-table-column-insert-button>
            </div>

            @if (settings?.route?.columns?.status) {
              <div class="th col-status" translate>
                Status
                <app-table-column-insert-button column="status"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.serviceType) {
              <div class="th col-service-type" translate>
                Type
                <app-table-column-insert-button column="serviceType"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.account) {
              <div class="th col-account" translate>
                Account
                <app-table-column-insert-button column="account"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.contact) {
              <div class="th col-contact" translate>
                Contact
                <app-table-column-insert-button column="contact"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.address) {
              <div class="th col-address" translate>
                Address
                <app-table-column-insert-button column="address"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.timeWindow) {
              <div class="th col-time-window" translate>
                Time Window
                <app-table-column-insert-button column="timeWindow"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.eta) {
              <div class="th col-eta" translate>
                ETA
                <app-table-column-insert-button column="eta"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.etd) {
              <div class="th col-etd" translate>
                ETD
                <app-table-column-insert-button column="etd"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.serviceTime) {
              <div class="th col-service-time" translate>
                Service Time
                <app-table-column-insert-button column="serviceTime"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.sla) {
              <div class="th col-sla" translate>
                SLA
                <app-table-column-insert-button column="sla"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.packages) {
              <div class="th col-packages" translate>
                Packages
                <app-table-column-insert-button column="packages"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.labels) {
              <div class="th col-labels" translate>
                Labels
                <app-table-column-insert-button column="labels"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.price) {
              <div class="th col-price" translate>
                Price
                <app-table-column-insert-button column="price"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.relations) {
              <div class="th col-relations" translate>
                Relations
                <app-table-column-insert-button column="relations"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.load?.weight) {
              <div class="th col-weight" translate>
                Weight
                <app-table-column-insert-button column="weight" group="load"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.load?.volume) {
              <div class="th col-volume" translate>
                Volume
                <app-table-column-insert-button column="volume" group="load"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.load?.pallets) {
              <div class="th col-pallets" translate>
                Pallets
                <app-table-column-insert-button column="pallets" group="load"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.load?.spots) {
              <div class="th col-spots" translate>
                Spots
                <app-table-column-insert-button column="spots" group="load"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.proNumber) {
              <div class="th col-pro-number" translate>
                Pro Number
                <app-table-column-insert-button column="proNumber"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.referenceIds) {
              <div class="th col-reference-ids" translate>
                Reference IDs
                <app-table-column-insert-button column="referenceIds"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.programType) {
              <div class="th col-program-type" translate>
                Program
                <app-table-column-insert-button column="programType"></app-table-column-insert-button>
              </div>
            }
            @if (settings?.route?.columns?.depotExternalId) {
              <div class="th col-depot-external-id" translate>
                Depot External ID
                <app-table-column-insert-button column="depotExternalId"></app-table-column-insert-button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Body: Handles vertical scrolling and horizontal scrolling -->
    <div class="body-container"
         #bodyContainer
         (scroll)="onBodyScroll($event)"
         cdkDropList
         [cdkDropListData]="tasks"
         id="{{panel.id + '-drilldown'}}"
         [cdkDropListConnectedTo]="allPanelIds"
         [cdkDropListDisabled]="!!isLoading || mutableRoute.isBlockedByUser"
         [cdkDropListSortPredicate]="sortPredicate"
         (cdkDropListEntered)="enter($event)"
         (cdkDropListDropped)="drop($event)">

      <div class="table-inner-wrapper">
        <div class="routes-stops-table-list-container">
          <ng-container *ngFor="let task of tasks; let index = index; trackBy: trackById">

            <!-- Row structure -->
            <div class="tr"
                 [ngClass]="{
                   'selected': selectedKeys[task.id],
                   'start-end-row': task.taskType === TaskType.Internal,
                   'highlight': highlightedActivity?.id === task.id || localHighlightedTaskIds.has(task.id)
                 }"
                 (mouseenter)="onHoverTask(task, true)"
                 (mouseleave)="onHoverTask(task, false)"
                 (contextmenu)="onRightClick($event, task)"
                 cdkDrag
                 [cdkDragDisabled]="task.taskType === TaskType.Internal || !!isLoading || mutableRoute.isBlockedByUser"
                 [cdkDragData]="task">

              <!-- Drag Preview -->
              <div *ngIf="selectedServiceIds?.length > 1 && selectedKeys[task.id]; else normalPreview">
                <div *cdkDragPreview id="app-planning-draft-jobs-panel-editable-list-preview-drag-multiple-jobs-container">
                  {{ 'DRAGGING_X_ITEMS.JOBS' | translate:{X: selectedServiceIds.length} }}
                </div>
              </div>

              <ng-template #normalPreview>
                <div *cdkDragPreview class="tr drag-preview route-drilldown-drag-preview">
                   <div class="td col-id">
                     <span *ngIf="task.taskType === TaskType.BundledStopover">
                       {{ 'Multi' | translate }} {{ 'TASK_PURPOSE.' + task.taskSpec.purpose | translate }} ({{ task.bundledTaskList?.length || task.bundledTaskIdList?.length }})
                     </span>
                     <span *ngIf="task.taskType !== TaskType.BundledStopover">
                       {{ task.serviceExternalId || task.serviceId || task.id }}
                     </span>
                   </div>
                   <div class="td col-address">{{ task.taskSpec.address | bringozAddress }}</div>
                </div>
              </ng-template>

              <!-- Drag Placeholder -->
              <div *cdkDragPlaceholder class="tr drag-placeholder"></div>

              <!-- Start / End Row Unified Layout -->
              <ng-container *ngIf="task.taskType === TaskType.Internal">
                <div class="td col-id sticky-col layout-row layout-align-start-center gap-5">
                  <bringoz-icon iconName="location-pin-outline" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="br-body-1 font-weight-600">{{ 'TASK_PURPOSE.' + task.taskSpec.purpose | translate }}</span>
                </div>
                <div *ngIf="settings?.route?.columns?.status" class="td col-status">---</div>
                <div *ngIf="settings?.route?.columns?.serviceType" class="td col-service-type">---</div>
                <div *ngIf="settings?.route?.columns?.account" class="td col-account">---</div>
                <div *ngIf="settings?.route?.columns?.contact" class="td col-contact">---</div>
                <div *ngIf="settings?.route?.columns?.address" class="td col-address text-ellipsis">
                  <span class="br-body-1 text-ellipsis">{{ task.taskSpec.address | bringozAddress }}</span>
                </div>
                <div *ngIf="settings?.route?.columns?.timeWindow" class="td col-time-window text-ellipsis">
                  <span class="br-body-1 text-ellipsis">{{ task.taskSpec | timeWindow }}</span>
                </div>
                <div *ngIf="settings?.route?.columns?.eta" class="td col-eta">---</div>
                <div *ngIf="settings?.route?.columns?.etd" class="td col-etd">---</div>
                <div *ngIf="settings?.route?.columns?.serviceTime" class="td col-service-time">---</div>
                <div *ngIf="settings?.route?.columns?.sla" class="td col-sla">---</div>
                <div *ngIf="settings?.route?.columns?.packages" class="td col-packages">---</div>
                <div *ngIf="settings?.route?.columns?.labels" class="td col-labels">---</div>
                <div *ngIf="settings?.route?.columns?.price" class="td col-price">---</div>
                <div *ngIf="settings?.route?.columns?.relations" class="td col-relations">---</div>
                <div *ngIf="settings?.route?.load?.weight" class="td col-weight">---</div>
                <div *ngIf="settings?.route?.load?.volume" class="td col-volume">---</div>
                <div *ngIf="settings?.route?.load?.pallets" class="td col-pallets">---</div>
                <div *ngIf="settings?.route?.load?.spots" class="td col-spots">---</div>
                <div *ngIf="settings?.route?.columns?.proNumber" class="td col-pro-number">---</div>
                <div *ngIf="settings?.route?.columns?.referenceIds" class="td col-reference-ids">---</div>
                <div *ngIf="settings?.route?.columns?.programType" class="td col-program-type">---</div>
                <div *ngIf="settings?.route?.columns?.depotExternalId" class="td col-depot-external-id text-ellipsis">
                  <span class="br-body-1 text-ellipsis">{{ task.taskSpec.depotReference?.externalId || '---' }}</span>
                </div>
              </ng-container>

              <!-- Normal Columns Layout -->
              <ng-container *ngIf="task.taskType !== TaskType.Internal">
                <!-- Checkbox + ID Link sticky column -->
                <div *ngIf="settings?.route?.columns?.id" class="td col-id sticky-col layout-row layout-align-start-center gap-5">

                  <!-- Indexes In Route -->
                  <div class="index-line-wrapper" [style.color]="mutableRoute.color" style="flex-shrink: 0;">
                    <div class="index-in-route-container" [style.border-color]="mutableRoute.color" style="flex-shrink: 0; z-index: 1;">
                      <div [style.background]="(highlightedActivity?.id === task.id || localHighlightedTaskIds.has(task.id)) ? mutableRoute.color : (mutableRoute.color + '20')"
                           [style.color]="(highlightedActivity?.id === task.id || localHighlightedTaskIds.has(task.id)) ? 'white' : mutableRoute.color"
                           [style.border-color]="mutableRoute.color"
                           [ngbTooltip]="('Stop Index' | translate) + ': ' + (index + taskIndexOffset)"
                           container="body"
                           openDelay="300">
                        {{ index + taskIndexOffset }}
                      </div>
                    </div>
                  </div>

                  <div cdkDragHandle style="flex-shrink: 0; display: flex; align-items: center; justify-content: center;">
                    <bringoz-icon iconName="drag" class="secondary-100 pointer"></bringoz-icon>
                  </div>

                  <app-bringoz-checkbox [isChecked]="selectedKeys[task.id]"
                                        (clickEvent)="onSelectedChange(task, !selectedKeys[task.id])"
                                        style="flex-shrink: 0; display: flex;">
                  </app-bringoz-checkbox>

                  <!-- Task Purpose Indication (P / D / O) -->
                  <app-task-purpose [purpose]="task.taskSpec.purpose" firstLetterOnly="true" style="flex-shrink: 0;"></app-task-purpose>

                  <span *ngIf="task.taskType === TaskType.BundledStopover"
                        class="bundle-header br-body-1 font-weight-600 text-ellipsis"
                        [ngClass]="task.taskSpec.purpose">
                    {{ 'Multi' | translate }} {{ 'TASK_PURPOSE.' + task.taskSpec.purpose | translate }} ({{ task.bundledTaskList?.length || task.bundledTaskIdList?.length }})
                  </span>

                  <app-service-link *ngIf="task.taskType === TaskType.Stopover"
                                    [serviceType]="purposeToServiceType[task.taskSpec.purpose]"
                                    [id]="task.serviceId"
                                    [externalId]="task.serviceExternalId"
                                    isAllowCopyButton="true"
                                    class="text-ellipsis">
                  </app-service-link>
                </div>

                <!-- Status -->
                <div *ngIf="settings?.route?.columns?.status" class="td col-status layout-row layout-align-start-center text-ellipsis">
                  <app-bringoz-status-tag [status]="task.status" [isSmall]="true"></app-bringoz-status-tag>
                </div>

                <!-- Service Type -->
                <div *ngIf="settings?.route?.columns?.serviceType" class="td col-service-type text-ellipsis layout-row layout-align-start-center gap-5">
                  <app-service-type-indication [serviceType]="purposeToServiceType[task.taskSpec.purpose]" [isShort]="true"></app-service-type-indication>
                  <span class="br-body-1 text-ellipsis">{{ 'TASK_PURPOSE.' + task.taskSpec.purpose | translate }}</span>
                </div>

                <!-- Account -->
                <div *ngIf="settings?.route?.columns?.account" class="td col-account text-ellipsis">
                  <ng-container *ngIf="accountReferencesMap[task.id]?.length === 1">
                    <app-demand-account-link class="text-ellipsis" style="width: 100%;" [account]="accountReferencesMap[task.id][0]"></app-demand-account-link>
                  </ng-container>
                  <span *ngIf="accountReferencesMap[task.id]?.length > 1" class="br-body-1 text-ellipsis">
                    {{ accountReferencesMap[task.id].length }} <span translate>Accounts</span>
                  </span>
                </div>

                <!-- Contact -->
                <div *ngIf="settings?.route?.columns?.contact" class="td col-contact text-ellipsis layout-row layout-align-start-center gap-5">
                  <bringoz-icon iconName="contact-circle" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="br-body-1 text-ellipsis">{{ task.taskSpec.contact?.name || '---' }}</span>
                </div>

                <!-- Address -->
                <div *ngIf="settings?.route?.columns?.address" class="td col-address text-ellipsis">
                  <span class="br-body-1 text-ellipsis" [appBringozTooltip]="task.taskSpec.address | bringozAddress" ngbTooltip>{{ task.taskSpec.address | bringozAddress }}</span>
                </div>

                <!-- Time Window -->
                <div *ngIf="settings?.route?.columns?.timeWindow" class="td col-time-window text-ellipsis layout-row layout-align-start-center gap-5">
                  <bringoz-icon iconName="time-window-outline" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="br-body-1 text-ellipsis">{{ task.taskSpec | timeWindow }}</span>
                </div>

                <!-- ETA -->
                <div *ngIf="settings?.route?.columns?.eta" class="td col-eta text-ellipsis layout-row layout-align-start-center gap-5">
                  <bringoz-icon iconName="eta" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="br-body-1 text-ellipsis">{{ task.routeAnalysis | bringozDate:'eta':true }}</span>
                </div>

                <!-- ETD -->
                <div *ngIf="settings?.route?.columns?.etd" class="td col-etd text-ellipsis layout-row layout-align-start-center gap-5">
                  <bringoz-icon iconName="etd" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="br-body-1 text-ellipsis">{{ task.routeAnalysis | bringozDate:'etd':true }}</span>
                </div>

                <!-- Service Time -->
                <div *ngIf="settings?.route?.columns?.serviceTime" class="td col-service-time text-ellipsis layout-row layout-align-start-center gap-5">
                  <bringoz-icon iconName="timer-outline" classSize="md" fill="#484848"></bringoz-icon>
                  <div *ngIf="!task.taskSpec?.detailedServiceTime" class="layout-row layout-align-start-center text-ellipsis">
                    <span class="br-body-1 text-ellipsis">{{ task.taskSpec?.serviceTime | bringozTimeConvert: true }}</span>
                  </div>
                  <app-task-detailed-service-time *ngIf="!!task.taskSpec?.detailedServiceTime"
                                                  class="margin-left-5 text-ellipsis"
                                                  [fontSize]="'br-body-1'"
                                                  [isAllowEdit]="false"
                                                  [detailedServiceTime]="task.taskSpec?.detailedServiceTime">
                  </app-task-detailed-service-time>
                </div>

                <!-- SLA -->
                <div *ngIf="settings?.route?.columns?.sla" class="td col-sla text-ellipsis">
                  <span class="br-body-1 text-ellipsis">{{ task.taskSpec.slaWindow | timeWindow }}</span>
                </div>

                <!-- Packages -->
                <div *ngIf="settings?.route?.columns?.packages" class="td col-packages text-ellipsis">
                  <app-bringoz-packages-items-display-list *ngIf="task.packageList?.[0]?.items?.length"
                                                           [items]="task.packageList[0].items">
                  </app-bringoz-packages-items-display-list>
                  <span *ngIf="!task.packageList?.[0]?.items?.length">---</span>
                </div>

                <!-- Labels -->
                <div *ngIf="settings?.route?.columns?.labels" class="td col-labels text-ellipsis">
                  <app-bringoz-labels-display *ngIf="task.tags?.length" [labels]="task.tags" maxItems="1"></app-bringoz-labels-display>
                  <span *ngIf="!task.tags?.length">---</span>
                </div>

                <!-- Price -->
                <div *ngIf="settings?.route?.columns?.price" class="td col-price text-ellipsis">
                  <span class="br-body-1 text-ellipsis">{{ task | taskCourierPrice }}</span>
                </div>

                <!-- Relations -->
                <div *ngIf="settings?.route?.columns?.relations" class="td col-relations">
                  <app-task-relations-indicator [relations]="relationsMap[task.id]"
                                                (onClick)="onRelationsClick($event, task)">
                  </app-task-relations-indicator>
                </div>

                <!-- Weight -->
                <div *ngIf="settings?.route?.load?.weight" class="td col-weight text-ellipsis">
                  <span class="br-body-1 text-ellipsis">{{ task.packageList | packageWeight:true }}</span>
                </div>

                <!-- Volume -->
                <div *ngIf="settings?.route?.load?.volume" class="td col-volume text-ellipsis">
                  <span class="br-body-1 text-ellipsis">{{ task.packageList | packageVolume:true }}</span>
                </div>

                <!-- Pallets -->
                <div *ngIf="settings?.route?.load?.pallets" class="td col-pallets text-ellipsis">
                  <span class="br-body-1 text-ellipsis">{{ task.packageList | packagePallets }}</span>
                </div>

                <!-- Spots -->
                <div *ngIf="settings?.route?.load?.spots" class="td col-spots text-ellipsis">
                  <span class="br-body-1 text-ellipsis">{{ task.packageList | packageSpots }}</span>
                </div>

                <!-- Pro Number -->
                <div *ngIf="settings?.route?.columns?.proNumber" class="td col-pro-number text-ellipsis">
                  <app-bringoz-items-list-display *ngIf="proNumbersMap[task.id]?.length" [items]="proNumbersMap[task.id]" [maxItems]="1" [isTransparentBackground]="true" [canCopy]="true"></app-bringoz-items-list-display>
                  <span *ngIf="!proNumbersMap[task.id]?.length">---</span>
                </div>

                <!-- Reference IDs -->
                <div *ngIf="settings?.route?.columns?.referenceIds" class="td col-reference-ids text-ellipsis gap-5">
                  <app-bringoz-items-list-display *ngIf="task.serviceInfo?.referenceIds?.length" [items]="task.serviceInfo.referenceIds" [maxItems]="1" [isTransparentBackground]="true"></app-bringoz-items-list-display>
                  <span *ngIf="!task.serviceInfo?.referenceIds?.length">---</span>
                </div>

                <!-- Program Type -->
                <div *ngIf="settings?.route?.columns?.programType" class="td col-program-type text-ellipsis">
                  <span class="br-body-1 text-ellipsis">{{ task.serviceInfo?.pricePlanType ? programs[task.serviceInfo.pricePlanType] : '---' }}</span>
                </div>

                <!-- Depot External ID -->
                <div *ngIf="settings?.route?.columns?.depotExternalId" class="td col-depot-external-id">---</div>
              </ng-container>

            </div>
          </ng-container>
        </div>
      </div>

    </div>
  </div>

  <app-bringoz-linear-progress *ngIf="loading$ | async as loading"></app-bringoz-linear-progress>
</div>
